import React, { createContext, useContext, useState } from 'react';

/** Which Business audience is selected: 'owner' or 'firm'. Shared by the home page card and the Business page. */
const BizContext = createContext(['owner', () => {}]);

export function BizProvider({ children }) {
  const state = useState('owner');
  return <BizContext.Provider value={state}>{children}</BizContext.Provider>;
}

export function useBiz() {
  return useContext(BizContext);
}
